import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import moment from 'moment';

export function todayOrBeforeDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }

    // moment() keeps the UTC mode set by the date picker (useUtc)
    const date = moment(control.value);
    if (!date.isValid()) {
      return null;
    }

    // Compare calendar days: a UTC midnight value must not shift to another local day
    return date.format('YYYY-MM-DD') > moment().format('YYYY-MM-DD')
      ? { afterToday: true }
      : null;
  };
}
